/* TALAS CONTACT TRACKING: ONE delegated click listener for WhatsApp, Call and Directions taps.
 * Sends GA4 events whatsapp_click, phone_click, directions_click with params
 *   branch (qz3|sja|ind4|unknown), link_location (header|footer|...), page_path, phone_number (wa/tel only).
 * Included once from layout/theme.liquid. Never blocks or alters navigation (capture phase, no preventDefault, try/catch).
 *
 * Branch: from the phone number in the link (wa.me/<n>, ?phone=<n>, tel:<n>) or the Google Maps cid / lat,lng, or an
 * explicit data-branch="qz3|sja|ind4" on the link or an ancestor (data-branch always wins).
 * Location: data-track-loc on the link or an ancestor wins, else the first matching selector in LOC, else the name of
 * the enclosing .shopify-section, else "other".
 *
 * Existing handlers (do not duplicate):
 *  - /pages/contact-talas: the page body (Shopify page, not theme) ships its own gtag handlers (trackAndRedirect on
 *    #wa-contact-btn plus a document click handler for wa/tel links) that fire whatsapp_click / phone_click AND the
 *    Google Ads conversion. While window.trackAndRedirect exists this file skips wa/tel and only handles directions.
 *  - GA4 event-create rules turn enhanced-measurement outbound "click" events on wa.me / api.whatsapp.com into an extra
 *    whatsapp_click with click_source=enhanced_measurement_outbound_click and no branch. Reports must exclude those
 *    (tools/contact_clicks.py does).
 * This file never fires Google Ads conversions. */
(function () {
  'use strict';
  if (window.__talasContactTrack) return;
  window.__talasContactTrack = 1;

  var GA4_ID = 'G-FNHRP56T1L';
  // last 9 digits of the national number -> branch
  var PHONES = { '566662075': 'qz3', '501996588': 'sja', '564045033': 'ind4' };
  var CIDS = { '12060948635059798897': 'qz3', '13226662547140987598': 'sja', '953378759255709748': 'ind4' };
  var COORDS = { '25.123,55.226': 'qz3', '25.348,55.638': 'sja', '25.334,55.404': 'ind4' };
  var LOC = [
    ['.tchat', 'chat_widget'],
    ['.tc-tab, .tc-tabs, .tc-mobile-bar', 'tab_bar'],
    ['.pdp-sticky', 'sticky_bar'],
    ['.tmm', 'mobile_menu'],
    ['pickup-availability, .pickup-availability-drawer, #PickupAvailabilityDrawer, .pk-drawer', 'pickup_drawer'],
    ['.pdp-contact', 'pdp'],
    ['.tp-contact', 'contact'],
    ['.tc__ask', 'product_card'],
    ['.th-cta', 'home_cta'],
    ['footer, .tc-footer', 'footer'],
    ['header, .tc-header, .tc-mega', 'header']
  ];
  var recent = {};

  function lastDigits(s) { s = String(s || '').replace(/\D/g, ''); return s.slice(-9); }
  function toBranch(v) { v = String(v || '').toLowerCase(); return v === 'ind4' || v === 'ia4' ? 'ind4' : (v === 'qz3' || v === 'sja') ? v : ''; }

  function kind(a) {
    var h = a.getAttribute('href') || '';
    if (/^tel:/i.test(h)) return 'phone_click';
    if (/^(https?:)?\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com|chat\.whatsapp\.com)\b/i.test(h) || /^whatsapp:/i.test(h)) return 'whatsapp_click';
    if (/^(geo|maps):/i.test(h) || /^(https?:)?\/\/(maps\.google\.[a-z.]+|maps\.app\.goo\.gl|goo\.gl\/maps|maps\.apple\.com|g\.page)\b/i.test(h) ||
        /^(https?:)?\/\/(www\.)?google\.[a-z.]+\/maps(?!\/embed)/i.test(h)) return 'directions_click';
    return '';
  }

  function phoneOf(h) {
    var m = h.match(/wa\.me\/\+?(\d+)/i) || h.match(/[?&]phone=\+?(\d+)/i) || h.match(/^tel:\s*([+\d%\s().-]+)/i);
    return m ? m[1].replace(/\D/g, '') : '';
  }

  function branchOf(a, k, h) {
    var el = a.closest('[data-branch]');
    var b = el && toBranch(el.getAttribute('data-branch'));
    if (b) return b;
    if (k === 'directions_click') {
      var c = h.match(/[?&]cid=(\d+)/i);
      if (c && CIDS[c[1]]) return CIDS[c[1]];
      var ll = h.match(/(-?\d+\.\d+)(?:,|%2C)(-?\d+\.\d+)/);
      if (ll) { var key = (+ll[1]).toFixed(3) + ',' + (+ll[2]).toFixed(3); if (COORDS[key]) return COORDS[key]; }
      var ce = a.closest('[data-lat][data-lng]');
      if (ce) { var k2 = (+ce.getAttribute('data-lat')).toFixed(3) + ',' + (+ce.getAttribute('data-lng')).toFixed(3); if (COORDS[k2]) return COORDS[k2]; }
      return 'unknown';
    }
    return PHONES[lastDigits(phoneOf(h))] || 'unknown';
  }

  function locOf(a) {
    var el = a.closest('[data-track-loc]');
    if (el && el.getAttribute('data-track-loc')) return el.getAttribute('data-track-loc');
    for (var i = 0; i < LOC.length; i++) if (a.closest(LOC[i][0])) return LOC[i][1];
    var s = a.closest('.shopify-section');
    if (s && s.id) {
      var n = s.id.replace(/^shopify-section-/, '').replace(/^.*__/, '').replace(/^template--\d+__/, '');
      if (n && !/^\d+$/.test(n)) return n.slice(0, 40);
    }
    return /^\/pages\/contact-talas/.test(location.pathname) ? 'contact' : 'other';
  }

  function gt() {
    if (typeof window.gtag === 'function') return window.gtag.apply(window, arguments);
    (window.dataLayer = window.dataLayer || []).push(arguments);
  }

  document.addEventListener('click', function (e) {
    try {
      if (!e.isTrusted || e.button > 0 || e.__talasTracked) return;
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var h = (a.getAttribute('href') || '').trim();
      var k = kind(a);
      if (!k) return;
      e.__talasTracked = 1;
      // the contact page body already reports wa/tel taps (see header); we only add directions there
      if (k !== 'directions_click' && typeof window.trackAndRedirect === 'function') return;
      var now = Date.now(), id = k + '|' + h;
      if (recent[id] && now - recent[id] < 600) return;
      recent[id] = now;
      var p = { send_to: GA4_ID, branch: branchOf(a, k, h), link_location: locOf(a), page_path: location.pathname, transport_type: 'beacon' };
      if (k !== 'directions_click') p.phone_number = phoneOf(h);
      gt('event', k, p);
    } catch (err) { /* tracking must never break a tap */ }
  }, true);
})();
